// coursesChatData.js
export const bot_data = [
  {
    title: "Basic Quran Reading",
    instructor: "Hafiz Bilal",
    price: "$30",
    duration: "30 min",
    availability: "24/7",
    description: "Learn to read Quran from scratch with proper Arabic pronunciation. Perfect for beginners who want to start their Quran journey.",
    level: "Beginner",
    schedule: "Any time - Self paced"
  },
  {
    title: "Tajweed Mastery",
    instructor: "Hafiz Qasim",
    price: "$30",
    duration: "30 min",
    availability: "24/7",
    description: "Master the rules of Tajweed - learning the alphabets of Quran, pronunciation rules (Makharij & Sifaat), and proper recitation.",
    level: "Intermediate",
    schedule: "Flexible timing"
  },
  {
    title: "Seerah of Prophet",
    instructor: "Hazrat Molana Bilal",
    price: "$35",
    duration: "30 min",
    availability: "Weekends",
    description: "Comprehensive study of Prophet Muhammad's (PBUH) life, teachings, and lessons for modern Muslims.",
    level: "All Levels",
    schedule: "Saturday & Sunday"
  },
  {
    title: "Hifz-e-Quran",
    instructor: "Hafiz Ijaz",
    price: "$50",
    duration: "30 min",
    availability: "24/7",
    description: "Quran memorization program with personalized schedules and regular revision. Perfect for those wanting to become Hafiz.",
    level: "Advanced",
    schedule: "Daily sessions"
  },
  {
    title: "Dua & Supplications",
    instructor: "Qari Omer",
    price: "$35",
    duration: "1 hour",
    availability: "Weekends",
    description: "Learn essential duas for daily life, morning/evening adhkar, and special supplications from Quran and Sunnah.",
    level: "Beginner",
    schedule: "Weekend classes"
  },
  {
    title: "Islamic History",
    instructor: "Qari Umair Farooqi",
    price: "$35",
    duration: "30 min",
    availability: "24/7",
    description: "Explore the rich history of Islam from the time of Prophets to the Golden Age and modern era.",
    level: "Intermediate",
    schedule: "Flexible"
  },
  {
    title: "Quran Tafseer",
    instructor: "Usman",
    price: "$35",
    duration: "1 hour",
    availability: "Weekends",
    description: "Deep understanding of Quranic verses with context, meanings, and practical applications in daily life.",
    level: "Advanced",
    schedule: "Weekend sessions"
  },
  {
    title: "Islamic Studies",
    instructor: "Salman",
    price: "$35",
    duration: "30 min",
    availability: "24/7",
    description: "Comprehensive course covering Aqeedah, Fiqh, Hadith, and modern Islamic issues.",
    level: "All Levels",
    schedule: "Flexible"
  },
  {
    title: "Quran Translation",
    instructor: "Yusuf",
    price: "$35",
    duration: "30 min",
    availability: "24/7",
    description: "Learn word-by-word Quran translation with basic Arabic grammar to understand Allah's message directly.",
    level: "Intermediate",
    schedule: "Flexible timing"
  }
];